import {
  SOCIAL_TEST_ACTION,
} from './constants';

export function socialTestAction() {
  return {
    type: SOCIAL_TEST_ACTION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SOCIAL_TEST_ACTION:
      return {
        ...state,
      };

    default:
      return state;
  }
}
